import {
  queryOrderGoodsOverviewApi,
  queryShopSettlementApi,
  getDeleteBillChannelListApi,
  queryOrderWaterTotalApi,
  queryBusinessWithTotalApi,
  queryBusinessWithDayApi,
  queryMemberStatisticsApi,
  queryMemberStatisticsWithDayApi,
  queryRechargeStatisticsApi,
  queryRechargeStatisticsWithDayApi,
  queryRechargeAdjustmentListApi,
  querySaleCardStatisticsApi,
  querySaleCardStatisticsWithDayApi,
  querySaleCardListApi,
  queryJFStatisticsApi,
  queryJFStatisticsWithDayApi,
  queryIntegralDetailListApi,
  queryYHQDetailListApi,
  queryYHQShopDetailListApi,
  queryYHQOrderDetailListApi,
  queryTZStatisticsApi,
  queryTZStatisticsWithDayApi,
  queryTQStatisticsWithDayApi,
  queryCouponDetailListApi,
  queryYHQDetailApi,
  queryGoodsByOrderApi,
  queryBrandShopSettlementApi,
  queryBrandBusinessStatisticApi,
  queryClientVisitDayStatisticsApi,
  queryGoodsVisitStatisticsApi,
  queryGoodsVisitDayStatisticsApi,
  queryRealRechargeUseMoneyDetailApi,
  queryShopSettlementDetailListApi,
  queryRealRechargeUseElseShopMoneyDetailApi,
  queryRealElseShopUseMoneyDetailApi,
  queryZSJFStatisticsWithDayApi,
  queryZSJFStatisticsApi,
  queryZSJFDetailListApi,
  queryHandoverRecordApi,
  queryReserveFundWaterApi,
  getReserveFundWaterCountApi,
  queryOrderErrandTotalListApi,
  queryOrderErrandIncomeDetailApi,
  getUserDepositAdjustCountListApi,
  getOverlordTaskStatisticsForPlatApi,
  queryShopDistriBalanceApi,
  queryShopDistriBalanceWaterApi,
  adjustShopDistriBalanceApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  商品统计
  async queryOrderGoodsOverviewAction(context, param) {
    const res = await queryOrderGoodsOverviewApi(param)
    return res
  },
  //  查询店间结算
  async queryShopSettlementAction(context, param) {
    const res = await queryShopSettlementApi(param)
    return res
  },
  //  获取已被删除的支付渠道列表
  async getDeleteBillChannelListAction(context, param) {
    const res = await getDeleteBillChannelListApi(param)
    return res
  },
  //  查询订单流水合计
  async queryOrderWaterTotalAction(context, param) {
    const res = await queryOrderWaterTotalApi(param)
    return res
  },
  //  营业统计合计
  async queryBusinessWithTotalAction(context, param) {
    const res = await queryBusinessWithTotalApi(param)
    return res
  },
  //  营业统计按日月
  async queryBusinessWithDayAction(context, param) {
    const res = await queryBusinessWithDayApi(param)
    return res
  },
  //  汇总合计
  async queryMemberStatisticsAction(context, param) {
    const res = await queryMemberStatisticsApi(param)
    return res
  },
  //  汇总按日月
  async queryMemberStatisticsWithDayAction(context, param) {
    const res = await queryMemberStatisticsWithDayApi(param)
    return res
  },
  //  充值收入汇总
  async queryRechargeStatisticsAction(context, param) {
    const res = await queryRechargeStatisticsApi(param)
    return res
  },
  //  充值收入按日月
  async queryRechargeStatisticsWithDayAction(context, param) {
    const res = await queryRechargeStatisticsWithDayApi(param)
    return res
  },
  //  充值\调账明细
  async queryRechargeAdjustmentListAction(context, param) {
    const res = await queryRechargeAdjustmentListApi(param)
    return res
  },
  //  购卡汇总
  async querySaleCardStatisticsAction(context, param) {
    const res = await querySaleCardStatisticsApi(param)
    return res
  },
  //  购卡按日月
  async querySaleCardStatisticsWithDayAction(context, param) {
    const res = await querySaleCardStatisticsWithDayApi(param)
    return res
  },
  //  购卡详情
  async querySaleCardListAction(context, param) {
    const res = await querySaleCardListApi(param)
    return res
  },
  //  积分汇总
  async queryJFStatisticsAction(context, param) {
    const res = await queryJFStatisticsApi(param)
    return res
  },
  //  积分按日月
  async queryJFStatisticsWithDayAction(context, param) {
    const res = await queryJFStatisticsWithDayApi(param)
    return res
  },
  //  积分详情列表
  async queryIntegralDetailListAction(context, param) {
    const res = await queryIntegralDetailListApi(param)
    return res
  },
  //  优惠券详情列表
  async queryYHQDetailListAction(context, param) {
    const res = await queryYHQDetailListApi(param)
    return res
  },
  //  优惠券门店详情列表
  async queryYHQShopDetailListAction(context, param) {
    const res = await queryYHQShopDetailListApi(param)
    return res
  },
  //  优惠券订单详情列表
  async queryYHQOrderDetailListAction(context, param) {
    const res = await queryYHQOrderDetailListApi(param)
    return res
  },
  //  调账汇总
  async queryTZStatisticsAction(context, param) {
    const res = await queryTZStatisticsApi(param)
    return res
  },
  //  调账按日月
  async queryTZStatisticsWithDayAction(context, param) {
    const res = await queryTZStatisticsWithDayApi(param)
    return res
  },
  //  调券按日月
  async queryTQStatisticsWithDayAction(context, param) {
    const res = await queryTQStatisticsWithDayApi(param)
    return res
  },
  //  调券明细
  async queryCouponDetailListAction(context, param) {
    const res = await queryCouponDetailListApi(param)
    return res
  },
  //  优惠券使用详情
  async queryYHQDetailAction(context, param) {
    const res = await queryYHQDetailApi(param)
    return res
  },
  //  查询菜品统计对应的订单
  async queryGoodsByOrderAction(context, param) {
    const res = await queryGoodsByOrderApi(param)
    return res
  },
  //  全品牌店间结算
  async queryBrandShopSettlementAction(context, param) {
    const res = await queryBrandShopSettlementApi(param)
    return res
  },
  //  查询全品牌营业统计信息
  async queryBrandBusinessStatisticAction(context, param) {
    const res = await queryBrandBusinessStatisticApi(param)
    return res
  },
  //  查询客户端访问日统计
  async queryClientVisitDayStatisticsAction(context, param) {
    const res = await queryClientVisitDayStatisticsApi(param)
    return res
  },
  //  查询商品访问统计
  async queryGoodsVisitStatisticsAction(context, param) {
    const res = await queryGoodsVisitStatisticsApi(param)
    return res
  },
  //  查询商品访问日统计
  async queryGoodsVisitDayStatisticsAction(context, param) {
    const res = await queryGoodsVisitDayStatisticsApi(param)
    return res
  },
  //  查询门店储值使用结算金额详情
  async queryRealRechargeUseMoneyDetailAction(context, param) {
    const res = await queryRealRechargeUseMoneyDetailApi(param)
    return res
  },
  //  查询店间结算详情列表
  async queryShopSettlementDetailListAction(context, param) {
    const res = await queryShopSettlementDetailListApi(param)
    return res
  },
  //  查询门店应收金额详情
  async queryRealRechargeUseElseShopMoneyDetailAction(context, param) {
    const res = await queryRealRechargeUseElseShopMoneyDetailApi(param)
    return res
  },
  //  查询门店应付金额详情
  async queryRealElseShopUseMoneyDetailAction(context, param) {
    const res = await queryRealElseShopUseMoneyDetailApi(param)
    return res
  },
  //  财务报表 - 会员统计 - 赠送积分按日、月
  async queryZSJFStatisticsWithDayAction(context, param) {
    const res = await queryZSJFStatisticsWithDayApi(param)
    return res
  },
  //  财务报表 - 会员统计 - 赠送积分汇总
  async queryZSJFStatisticsAction(context, param) {
    const res = await queryZSJFStatisticsApi(param)
    return res
  },
  //  财务报表 - 会员统计 - 赠送积分详情列表
  async queryZSJFDetailListAction(context, param) {
    const res = await queryZSJFDetailListApi(param)
    return res
  },
  //  查询交接记录
  async queryHandoverRecordAction(context, param) {
    const res = await queryHandoverRecordApi(param)
    return res
  },
  //  查询储备金流水
  async queryReserveFundWaterAction(context, param) {
    const res = await queryReserveFundWaterApi(param)
    return res
  },
  //  获取储备金流水统计
  async getReserveFundWaterCountAction(context, param) {
    const res = await getReserveFundWaterCountApi(param)
    return res
  },
  //  查询跑腿人员对应订单合计列表
  async queryOrderErrandTotalListAction(context, param) {
    const res = await queryOrderErrandTotalListApi(param)
    return res
  },
  //  查询跑腿人员收益明细
  async queryOrderErrandIncomeDetailAction(context, param) {
    const res = await queryOrderErrandIncomeDetailApi(param)
    return res
  },
  //  获取用户押金流调整统计
  async getUserDepositAdjustCountListAction(context, param) {
    const res = await getUserDepositAdjustCountListApi(param)
    return res
  },
  //  获取霸王任务统计
  async getOverlordTaskStatisticsForPlatAction(context, param) {
    const res = await getOverlordTaskStatisticsForPlatApi(param)
    return res
  },
  //  查询门店分销余额
  async queryShopDistriBalanceAction(context, param) {
    const res = await queryShopDistriBalanceApi(param)
    return res
  },
  //  查询门店分销余额流水
  async queryShopDistriBalanceWaterAction(context, param) {
    const res = await queryShopDistriBalanceWaterApi(param)
    return res
  },
  //  调整门店分销余额
  async adjustShopDistriBalanceAction(context, param) {
    const res = await adjustShopDistriBalanceApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
